import React, { Component } from 'react'
import { Table } from 'reactstrap';

import CreateGiftcard from '../modals/createGiftcard';
import RemoveItem from '../modals/removeItem';
import itemStore from '../../../stores/item-store';
import swal from 'sweetalert';

export default class Giftcards extends Component {

    constructor(props) {
        super(props);
        this.state = {
            giftcard: this.props.giftcards
        }
    }

    componentDidMount = () => {
        let { giftcards } = this.props;
        giftcards = giftcards.map((pack, index) => {
            return { ind: index + 1, ...pack }
        })
        this.setState({ giftcard: giftcards }, () => {
        })
    }

    componentWillReceiveProps(nextProps) {
        let { giftcards } = nextProps;
        giftcards = giftcards.map((pack, index) => {
            return { ind: index + 1, ...pack }
        })
        this.setState({ giftcard: giftcards }, () => {
        })
    }

    timer;
    handleOrderChange = (event, ind) => {
        let _giftcards = this.state.giftcard;
        _giftcards[ind].ind = event.target.value
        this.setState({ giftcard: _giftcards })
        if (!event.target.value) {
            return
        }
        const eValue = event.target.value;
        let payload = { newIndex: Number(eValue), oldIndex: ind };
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.handleResponse(payload, Number(eValue));
        }, 2000)
    };

    handleResponse = async (payload, eValue) => {
        if (eValue <= this.state.giftcard.length && eValue > 0 && Number.isInteger(eValue) && (payload.newIndex-1) != payload.oldIndex) {
            const response = await itemStore.updateOrderGiftCard(payload);
            if (response) {
                swal({
                    title: "Success",
                    text: "Gift Card Updated Successfully",
                    icon: "success",
                    dangerMode: false,
                });
                await itemStore.loadItems();
            }
        }
        else {
            swal({
                title: "Warning",
                text: "You cannot enter an order that is equal, less than or greater than the maximum order range.",
                icon: "error",
                dangerMode: true,
            })
        }
    };

    renderGiftcards = () => {
        let { categories } = this.props;
        if (this.state.giftcard != undefined) {
            return this.state.giftcard.map((item, index) => {
                return (
                    <tr key={`discountRow${index}`}>
                        <th scope="row" data-id={item._id}>
                            <input className="orderField" value={item.ind} onChange={(e) => { this.handleOrderChange(e, index) }}/>
                        </th>
                        <td>{item.item}</td>    
                        <td>{item.tickets}</td>
                        <td>{item.expiryInDays}</td>
                        <td >${Math.abs(item.price).toFixed(2)}</td>
                        <td >{!isNaN(item.taxableAmount) ? "$" + Math.abs(item.taxableAmount).toFixed(2) : 0}</td>
                        <td>{item.tandemPackageName}</td>
                        <td>{item.videoPackageName}</td>
                        <td>{item.studentPackageName}</td>
                        <td>{item.isActive ? 'yes' : 'no'}</td>
                        <td>
                            <CreateGiftcard isEdit={true} item={item} categories={categories} />&nbsp;&nbsp;
                            <RemoveItem item={item} />
                        </td>
                    </tr>
                )
            })
        } else {
            return null;
        }
    }
    returnUniqueIndex = () => {
        let { categories, giftcards } = this.props;
        let uniqueArr = giftcards.map(ele => ele?.imageIndex);
        let uniqueIndex = 1;
        for (let i = 0; i < giftcards.length; i++) {
            if (uniqueArr.includes(uniqueIndex)) {
                uniqueIndex = uniqueIndex + 1;
            }
            else {
                break;
            }
        }
        return uniqueIndex;
    }

    render() {
        let { categories, giftcards } = this.props;
        let uniqueIndex = this.returnUniqueIndex();
        return (
            <Table>
                <thead className="main-heading">
                    <tr>
                        <th>
                            <CreateGiftcard categories={categories} uniqueIndex={uniqueIndex} />
                        </th>
                        <th>Name</th>
                        <th>Tickets</th>
                        <th>Num redeemed</th>
                        <th>Price</th>
                        <th>Taxable Amount</th>
                        <th>Tandem Package</th>
                        <th>Video Package</th>
                        <th>Student Package</th>
                        <th>Active</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="priceHeading">
                        <td colSpan="3"></td>
                    </tr>
                    {this.renderGiftcards()}
                </tbody>
            </Table>
        )
    }
}
